import { Typography } from '@mui/material';

const ErrorMessage = ({ message, children }) => {
  return (
    <Typography sx={{ fontSize: '1.25rem', paddingTop: '0.25rem', color: '#ED1C24' }}>
      {message || children}
    </Typography>
  );
};
export default ErrorMessage;
